import { Tag, TagLabel, TagLeftIcon, type TagProps } from "@chakra-ui/react";
import { forwardRef } from "react";
import { HiSparkles } from "react-icons/hi2";

export const AiSuggestionTag = forwardRef<HTMLSpanElement, TagProps & { label: string }>(({ label, ...props }, ref) => (
  <Tag ref={ref} size="sm" colorScheme="purple" variant="subtle" textTransform="none" {...props}>
    <TagLeftIcon as={HiSparkles} boxSize="3" />
    <TagLabel>{label}</TagLabel>
  </Tag>
));

AiSuggestionTag.displayName = "AiSuggestionTag";
